import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

gsap.registerPlugin(MotionPathPlugin);

export default class CoreHero extends DefaultBlock {
	init() {
		const flair = this.block.querySelector("#core-hero-flair");
		this.flair = flair;

		const el = {
			circlesCenter: flair.querySelector("#core_circles_center"),
			circlesLeft: flair.querySelector("#core_circles_left"),
			circlesRight: flair.querySelector("#core_circles_right"),
			circlesCenterLeft: flair.querySelector("#core_circles_center_left"),
			circlesCenterRight: flair.querySelector("#core_circles_center_right"),
			assets: [
				flair.querySelector("#core_flair_asset_1"),
				flair.querySelector("#core_flair_asset_2"),
				flair.querySelector("#core_flair_asset_3"),
				flair.querySelector("#core_flair_asset_4"),
				flair.querySelector("#core_flair_asset_5"),
				flair.querySelector("#core_flair_asset_6"),
				flair.querySelector("#core_flair_asset_7"),
			],
			lineLeftTopTop: flair.querySelector("#core_line_left_top_top"),
			lineLeftTopBottom: flair.querySelector("#core_line_left_top_bottom"),
			lineLeftBottomTop: flair.querySelector("#core_line_left_bottom_top"),
			lineLeftBottomBottom: flair.querySelector(
				"#core_line_left_bottom_bottom"
			),
			lineRightTopTop: flair.querySelector("#core_line_right_top_top"),
			lineRightTopBottom: flair.querySelector("#core_line_right_top_bottom"),
			lineRightBottomTop: flair.querySelector("#core_line_right_bottom_top"),
			lineRightBottomBottom: flair.querySelector(
				"#core_line_right_bottom_bottom"
			),
		};
		this.el = el;

		this.bounds = null;
		this.leftPosition = null;
		this.rightPosition = null;

		this.initCoreHero();
	}

	setCoreMotion() {
		gsap.set(this.el.assets, {
			scaleY: 0,
			rotationY: 90,
			yPercent: 100,
			transformOrigin: "50% 50%",
		});

		gsap.set(this.el.circlesCenter, {
			transformOrigin: "50% 50%",
		});
	}

	getCoreBounds() {
		// Calculate left positioning
		this.leftPosition = MotionPathPlugin.getRelativePosition(
			this.el.circlesCenterLeft,
			this.el.circlesLeft,
			[0.5, 0.5],
			[0.5, 0.5]
		);

		// Calculate right positioning
		this.rightPosition = MotionPathPlugin.getRelativePosition(
			this.el.circlesCenterRight,
			this.el.circlesRight,
			[0.5, 0.5],
			[0.5, 0.5]
		);
	}

	playCoreMotion() {
		const tl = gsap.timeline({
			delay: 1,
			repeat: -1,
			repeatDelay: 3,
		});

		watchPreferredMotion(() => {
			tl.to(
				this.el.circlesCenterLeft,
				{
					x: this.leftPosition.x,
					ease: "back.out(1.5)",
					duration: 1.2,
				},
				0
			);

			tl.to(
				this.el.circlesCenterRight,
				{
					x: this.rightPosition.x,
					ease: "back.out(1.5)",
					duration: 1.2,
				},
				0
			);

			tl.to(
				[this.el.lineRightTopTop, this.el.lineRightTopBottom],
				{
					keyframes: {
						x: [0, -20, -10, -30, 0],
					},
					ease: "back.out(1.5)",
					stagger: 0.1,
					duration: 0.6,
				},
				0
			);

			tl.to(
				[this.el.lineRightBottomTop, this.el.lineRightBottomBottom],
				{
					keyframes: {
						x: [0, -100, 0],
					},
					ease: "back.out(1.5)",
					stagger: 0.1,
					duration: 0.6,
				},
				0
			);

			tl.to(
				[this.el.lineLeftTopTop, this.el.lineLeftTopBottom],
				{
					keyframes: {
						x: [0, 20, 10, 30, 0],
					},
					ease: "back.out(1.5)",
					stagger: 0.1,
					duration: 0.6,
				},
				0
			);

			tl.to(
				[this.el.lineLeftBottomTop, this.el.lineLeftBottomBottom],
				{
					keyframes: {
						x: [0, 100, 0],
					},
					ease: "back.out(1.5)",
					stagger: 0.1,
					duration: 0.6,
				},
				0
			);

			tl.to(
				this.el.assets,
				{
					scaleY: 1,
					rotationY: 0,
					ease: "back.out(1.5)",
					duration: 0.6,
					stagger: {
						from: "center",
						grid: [1, 7],
						amount: 0.25,
					},
				},
				0
			);

			tl.to(
				this.el.circlesCenterLeft,
				{
					x: 0,
					ease: "back.in(1.2)",
					duration: 0.8,
				},
				2
			);

			tl.to(
				this.el.circlesCenterRight,
				{
					x: 0,
					ease: "back.in(1.2)",
					duration: 0.8,
				},
				2
			);

			tl.to(
				this.el.assets,
				{
					scaleY: 0,
					rotationY: 90,
					ease: "back.in(1.2)",
					stagger: {
						from: "edges",
						grid: [1, 7],
						amount: 0.25,
					},
				},
				2
			);

			tl.to(
				this.el.circlesCenter,
				{
					rotation: 360,
					ease: "power2.in",
					duration: 1,
				},
				3
			);
		});
	}

	initCoreHero() {
		this.getCoreBounds();
		this.setCoreMotion();
		this.playCoreMotion();

		window.addEventListener("resize", this.getCoreBounds.bind(this));
	}
}
